import { render, staticRenderFns } from "./BetLayout.vue?vue&type=template&id=705a0e82&scoped=true&"
import script from "./BetLayout.vue?vue&type=script&lang=js&"
export * from "./BetLayout.vue?vue&type=script&lang=js&"
import style0 from "./BetLayout.vue?vue&type=style&index=0&id=705a0e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a0e82",
  null
  
)

export default component.exports